import styled from '@emotion/styled';

const Section = styled('section')({
  marginBottom: 32,
  ':last-child': {
    marginBottom: 0,
  },
});

export default Section;
